import React, { useMemo, useState } from 'react';
import { Typography } from '@mui/material';
import moment from 'moment';
import { IColumnProps } from 'devextreme-react/data-grid';
import { useParams } from 'react-router-dom';

import GridTable from '../../../../../components/GridTable/gridTable';
import CompareRow from './row/CompareRow';
import { specifiedStore, FULLDATE_FORMAT, getKeysList } from './audit-utils';
import Table from '../../../../../components/Table';

const additionalColumns: IColumnProps [] = [
  {
    dataField: 'record_id',
    caption: 'record_id',
    alignment: 'center'
  },
  {
    dataField: 'login',
    caption: 'login',
    alignment: 'center'
  },
  {
    dataField: 'full_name',
    caption: 'full_name',
    alignment: 'center'
  },
  {
    dataField: 'password_expired',
    caption: 'password_expired',
    alignment: 'center'
  },
  {
    dataField: 'blocked',
    caption: 'blocked',
    alignment: 'center'
  },
  {
    dataField: 'deleted',
    caption: 'deleted',
    alignment: 'center'
  },
  {
    dataField: 'allow_change_pwd',
    caption: 'allow_change_pwd',
    alignment: 'center'
  },
  {
    dataField: 'account_expired',
    caption: 'account_expired',
    alignment: 'center'
  },
  {
    dataField: 'locale',
    caption: 'locale',
    alignment: 'center'
  }
];

export default function UsersAudit() {
  const { userId, companyId} = useParams();

  const [ store, setStore ] = useState<Array<any>>([]);

  const [ userFullName, setUserFullName ] = useState<string | null>('');

  // we use a default period of 1 week for data on server
  const [ dateStart, setDateStart ] =
    useState<string>(moment().subtract(1, 'weeks').format(FULLDATE_FORMAT));
  const [ dateEnd, setDateEnd ] =
    useState<string>(moment().format(FULLDATE_FORMAT));

  return useMemo(
    () => (
      <div data-test={'user-audit'}>
        <Table
          backButton={`/companies/users/list/${companyId}`}
          title={
            <Typography variant="h5" data-test={'back-button-title'}>
              User { userFullName } audit
            </Typography>
          }
          options={{
            moduleName: '',
            apiUrl: `/users/${userId}/audit`,
            dataSourceKey: 'users_history',
            dataStoreKey: '',
            searchKey: ''
          }}
          onDataChange={(data: { [k: string]: any }) => {
            setUserFullName(data?.user?.full_name);
          }}
          filter={{
            withPageSize: false,
            inputs: [
              {
                type: 'rangeDatePicker',
                name: 'rangeDatePicker',
                label: 'Pick dates interval to filter data',
                startName: 'date_from',
                endName: 'date_to',
                dateRangeStart: dateStart,
                dateRangeEnd: dateEnd,
              }
            ],
          }}
          receivedStore={store}
          withSorting={false}
          noDataText={'No matching records found. Try to choose the correct filters.'}
          columns={[
            {
              caption: 'Who changed',
              cellRender: (data) => {
                return(
                  <span>{data.data.user_id ? data.data.user_id : 'Unknown'}</span>
                )
              },
              width: '8%'
            },
            {
              caption: 'Application',
              cellRender: (data) => {
                return(
                  <span>{data.data.application ? data.data.application : 'Unknown'}</span>
                )
              },
              width: '8%'
            },
            {
              dataField: 'description',
              caption: 'Operation',
              width: '8%'
            },
            {
              dataField: 'change_time',
              caption: 'When Made',
              width: '8%'
            },
            {
              dataField: 'Diff',
              cellRender: (data) => {
                return(
                  <GridTable
                    receivedStore={specifiedStore(data.data, ['access_level', 'is_two_factor_enabled'])?.diff}
                    columns={additionalColumns}
                    keyExpr='record_id'
                    dataRowRender={(data) => CompareRow(data, getKeysList(additionalColumns))}
                  />
                )
              },
              caption: 'Diff'
            }
          ]}
        />
      </div>
    ),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [store, userFullName, companyId, dateStart, dateEnd]
  );
}

